/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';

export default class GetGraphsService extends BaseService {
  constructor() {
    super(constants.GET_GRAPHS, 'graphListStatus');
  }

  async handleEvent(eventName, event) {
    const { headers } = utils.buildRequestPartsFromPayload(event);
    const isTemplateList = event.payload?.template === true;
    const type = event.payload?.type;
    const option = event.payload?.option;
    const requestConfig = { headers };
    if (isTemplateList) {
      requestConfig.params = {
        template: true,
        ...(type ? { type } : {}),
        ...(option ? { option } : {})
      };
    }

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get('/graphs', { ...requestConfig, headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get('/graphs', requestConfig);
  }

  handleResponse(response) {
    const { data } = response;
    const graphListModel = Framework.getStoreRegistry().getStore('graphListModel');

    if (data && data.success) {
      graphListModel.setGraphs({
        graphs: data.graphs || []
      });
    } else {
      graphListModel.setError(data?.message || 'Failed to load graph list');
    }
  }

  handleError(error) {
    const graphListModel = Framework.getStoreRegistry().getStore('graphListModel');
    const { response } = error;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      graphListModel.setError(data?.message || 'Failed to load graph list');
    } else if (error.message === 'timeout of 60000ms exceeded') {
      graphListModel.setError('Request timeout. Please try again.');
    } else {
      graphListModel.setError(error.message || 'Failed to load graph list');
    }
  }
}
